import i18next from 'i18next'
import { baseDateInput, baseSelectInput, baseTextAreaInput, baseTextInput } from '../fieldTypes'
import { noteFields } from './fields'

export const noteFieldTypes = () => {
    const { t } = i18next

    return {
        [noteFields.NOTE_TITLE]: {
            ...baseTextInput,
            name: noteFields.NOTE_TITLE,
            label: t('app.common.title'),
            colProps: {
                sm: 12,
            },
        },
        [noteFields.NOTE_DATE]: {
            ...baseDateInput,
            name: noteFields.NOTE_DATE,
            label: t('app.common.date'),
            colProps: {
                sm: 12,
            },
        },
        [noteFields.NOTE]: {
            ...baseTextAreaInput,
            name: noteFields.NOTE,
            label: t('form.notes.note'),
            colProps: {
                sm: 12,
            },
            inputProps: {
                style: { resize: 'none', height: '127px' },
            },
            maxLenFeedback: 1000,
            hint: t('form.contact.description.hint'),
        },
        [noteFields.NOTE_AGENT_ID]: {
            ...baseSelectInput,
            name: noteFields.NOTE_AGENT_ID,
            label: t('app.common.agent'),
            colProps: {
                sm: 12,
            },
        },
    }
}
